import React, {Component} from 'react';

import Search from "../core/Search";
import Dialog from "../util/Dialog";
import SettingsDialog from "./SettingsDialog";
import authService from "../../AuthService";

class Settings extends Component {

    constructor(props) {
        super(props);

        this.checkCapitaine().then(isCapitaine => {
            if (isCapitaine) {
                window.location.replace("/admin/reservations");
            }
        });

        this.clearCache().then(r => {}).then(() => console.log("Cache cleared."));

        this.state = {
            rootId: null,
            screenId: this.props.screenId,
            workflowId: this.props.workflowId,
            path: this.props.path
        }

        this.externalCall = this.externalCall.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
    }

    async checkCapitaine() {
        const res = await authService.getUserById();
        return  res.data.data.capitaine === "oui";
    }

     async clearCache() {
        await authService.clearCache();
    }

    externalCall(method) {
        let id = method.split("-")[1];
        method = method.split("-")[0];
        if (method === "dialogForm") {
            this.setState({rootId: id});
            this.setState({method: method});
        }
    }

    closeDialog(e, validMessage, errorMessage) {
        document.location = this.state.path;
    }

    render() {
        return (
            <React.Fragment>
                <Search
                    initData={{DATAGRID_SCREEN_ID: this.state.screenId}}
                    externalCall={this.externalCall} />

                {!!this.state.method &&
                    <Dialog close={this.closeDialog}>
                        <SettingsDialog
                            closeDialog={this.closeDialog}
                            rootId={this.state.rootId}
                        	workflowId={this.state.workflowId}
                        	path={this.state.path}
                        />
                    </Dialog>
                }
            </React.Fragment>
        );
    }
}

export default Settings;
